import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'projects/vl/src/environments/environment';
import { UPUtilityService } from 'up';

@Component({
  selector: 'vl-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  errorMessageKey: string = 'GENERIC.ERROR.MESSAGE';

  constructor(
    private upUtilityService: UPUtilityService,
    private translate: TranslateService,
    private router: Router
  ) {
    if (this.router.getCurrentNavigation()?.extras.state?.['translateKey'])
      this.errorMessageKey =
        this.router.getCurrentNavigation()?.extras.state?.['translateKey'];
  }

  ngOnInit(): void {
    const errorPageTitle =
      this.translate.instant('GENERIC.PAGE_TITLE') +
      this.translate.instant('GENERIC.ERROR.PAGE_TITLE');
    this.upUtilityService.setPageTitle(errorPageTitle);
  }

  onExitClick() {
    this.upUtilityService.returnToCourse(`${environment.apiUrl}/vl`);
  }
}
